module.exports = __webpack_public_path__ + "static/media/flashInfo.edb27e81.svg";